import { api } from '@/lib/axios'

export interface NotificationPreferences {
  notify_telegram: boolean
  notify_yomi: boolean
  notify_sniper: boolean
  notify_jifu: boolean
  notify_makatsu: boolean
  telegram_linked: boolean
  telegram_configured: boolean
}

export type PreferencesUpdate = Partial<
  Pick<NotificationPreferences, 'notify_telegram' | 'notify_yomi' | 'notify_sniper' | 'notify_jifu' | 'notify_makatsu'>
>

export interface LinkResponse {
  deep_link: string
  bot_username: string | null
}

export const notificationsService = {
  async getPreferences(): Promise<NotificationPreferences> {
    const { data } = await api.get('/notifications/preferences')
    return data
  },
  async updatePreferences(update: PreferencesUpdate): Promise<NotificationPreferences> {
    const { data } = await api.put('/notifications/preferences', update)
    return data
  },
  async link(): Promise<LinkResponse> {
    const { data } = await api.post('/notifications/telegram/link')
    return data
  },
  async unlink(): Promise<void> {
    await api.post('/notifications/telegram/unlink')
  },
  async test(): Promise<void> {
    await api.post('/notifications/telegram/test')
  },
  // Admin: registra il webhook del bot sul dominio di produzione.
  async setupWebhook(baseUrl?: string): Promise<{ status: string; url: string }> {
    const { data } = await api.post('/notifications/telegram/setup-webhook', baseUrl ? { base_url: baseUrl } : {})
    return data
  },
}
